import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const LOADER_SIZE = 50

class LoadingStatusContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    blockContentUntilLoaded: PropTypes.bool,
    /* mapped props */
    loadingStatus: PropTypes.array.isRequired,
  }

  static defaultProps = {
    blockContentUntilLoaded: false,
  }

  static mapStateToProps(state) {
    return {
      loadingStatus: state.loadingStatus,
    }
  }

  static styles = () => ({
    overlay: {
      position: 'fixed',
      left: 0,
      top: '74px', // header height, need to be responsive
      width: '100vw',
      height: '100%',
      background: 'rgba(255, 255, 255, 0.5)',
      zIndex: 1050, // higher than mobile stepper, lower than everything else https://material-ui.com/customization/z-index/, leaflet controls are at 1000
    },
    blocking: {
      background: '#f3f3f6',
    },
    loaderPosition: {
      width: LOADER_SIZE,
      height: LOADER_SIZE,
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1051,
    },
  })

  render() {
    const { classes, blockContentUntilLoaded } = this.props

    return (
      <>
        { this.props.loadingStatus.length > 0 && (
        <div className={`${classes.overlay} ${blockContentUntilLoaded && classes.blocking}`}>
          <div className={classes.loaderPosition}>
            <CircularProgress size={LOADER_SIZE} />
          </div>
        </div>
        )}
      </>
    )
  }
}

export default connect(
  LoadingStatusContainer.mapStateToProps,
)(withStyles(LoadingStatusContainer.styles)(LoadingStatusContainer))
